import {
  PersonStanding,
  Shield,
  Home,
  TreePine,
  Crosshair,
  Telescope,
  Bug,
  MapPin,
  type LucideIcon,
} from 'lucide-react'

export const POINT_ICONS: Record<string, { icon: LucideIcon; label: string; color: string }> = {
  infantry: { icon: PersonStanding, label: 'Infantry', color: '#ec4899' }, // pink
  tank:     { icon: Shield,         label: 'Tank',     color: '#3b82f6' }, // blue
  roof:     { icon: Home,           label: 'Roof',     color: '#f97316' }, // orange
  bush:     { icon: TreePine,       label: 'Bush',     color: '#22c55e' }, // green
  mg:       { icon: Telescope,      label: 'MG',       color: '#ef4444' }, // red
  snipe:    { icon: Crosshair,      label: 'Snipe',    color: '#a855f7' }, // purple
  glitch:   { icon: Bug,            label: 'Glitch',   color: '#92400e' }, // brown
  other:    { icon: MapPin,         label: 'Other',    color: '#eab308' }, // yellow
}

export function getIconColor(iconType: string): string {
  return POINT_ICONS[iconType]?.color || POINT_ICONS.other.color
}

/**
 * Simgenin görünen adı. `POINT_ICONS.label` İngilizce kalır (kod içi kimlik),
 * ekrana basılan ad çeviriden okunur — tanınmayan tip "Diğer"e düşer.
 */
export function pointIconLabel(
  iconType: string,
  T: { strategicPoints: { iconTypes: Record<string, string> } },
): string {
  return T.strategicPoints.iconTypes[iconType] ?? T.strategicPoints.iconTypes.other
}
